import { type CSSProperties, type FC } from 'react'

import type { IconProps } from './types'
import { cx } from './utils'

import './Icon.scss'

export const createIcon = (src: string, displayName: string): FC<IconProps> => {
    const IconComponent: FC<IconProps> = ({
        size = 16,
        className,
        alt = '',
        style,
        color,
        ...rest
    }) => {
        const { color: styleColor, ...restStyle } = (style ?? {}) as CSSProperties
        const resolvedColor = color ?? styleColor
        const dimensions = { width: size, height: size, ...restStyle }

        if (resolvedColor) {
            return (
                <span
                    role={alt ? 'img' : undefined}
                    aria-label={alt || undefined}
                    aria-hidden={alt ? undefined : true}
                    className={cx('Icon', 'Icon--tinted', className)}
                    style={{
                        ...dimensions,
                        color: resolvedColor,
                        ['--icon-url' as string]: `url("${src}")`,
                    }}
                    {...rest}
                />
            )
        }

        return (
            <img
                src={src}
                alt={alt}
                className={cx('Icon', className)}
                style={dimensions}
                {...rest}
            />
        )
    }

    IconComponent.displayName = `Icon.${displayName}`
    return IconComponent
}
